import React from "react";
import { IntakeWithEditedFlags } from "../../data/plan";
import { ConsumedCell } from "./plannedIntakeUtils";
import { ConsumedEntryCard } from "./ConsumedEntryCard";

export function IntakeConsumedSection(props: {
  consumed: ConsumedCell[];
  expandedCards: Set<string>;
  onToggleExpand: (sig: string) => void;
  onPatchIntake: (
    sig: string,
    index: number,
    mutate: (i: IntakeWithEditedFlags) => void,
  ) => void;
  onOpenPicker: (sig: string, index: number) => void;
  onRemoveIntake: (sig: string, index: number) => void;
}) {
  if (props.consumed.length === 0) return null;
  return (
    <div className="flex w-full flex-col gap-2">
      <p className="px-1 text-xs font-semibold uppercase tracking-wider text-ink-muted">
        Verzehrt ({props.consumed.length})
      </p>
      {props.consumed.map((c) => (
        <ConsumedEntryCard
          key={c.sig}
          cell={c.cell}
          personName={c.personName}
          expanded={props.expandedCards.has(c.sig)}
          onToggleExpand={() => props.onToggleExpand(c.sig)}
          onPatchIntake={(index, mutate) =>
            props.onPatchIntake(c.sig, index, mutate)
          }
          onOpenProductPicker={(index) =>
            props.onOpenPicker(c.sig, index)
          }
          onRemoveIntake={(index) => props.onRemoveIntake(c.sig, index)}
        />
      ))}
    </div>
  );
}
